import { createSlice } from '@reduxjs/toolkit';
import modifyField from '@/utils/redux/modifyField';
export const initialState = {
    modals: {
        confirmStartPlannedTrip: {
            visibility: false,
            defaultValues: {
                tripRequestId: '',
                plannedPickUpAt: null,
                cost: null
            }
        },
        hintStatus: {
            visibility: false,
            defaultValues: { status: null, plannedTripStartBefore: null }
        },
        changePrice: {
            visibility: false,
            defaultValues: { tripId: null, date: null, currency: null, complaint: null }
        }
    }
};
export const tripsSlice = createSlice({
    name: 'trips',
    initialState,
    reducers: {
        setTripsPopup: {
            reducer(state, action) {
                const { modal, visibility, defaultValues } = action === null || action === void 0 ? void 0 : action.payload;
                state.modals = modifyField(state.modals, modal, {
                    visibility,
                    defaultValues: Object.assign(Object.assign({}, state.modals[modal].defaultValues), defaultValues)
                });
            },
            prepare(modal, visibility, defaultValues) {
                return { payload: { modal, visibility, defaultValues } };
            }
        }
    }
});
const { setTripsPopup } = tripsSlice.actions;
export const TripsActionCreators = { setTripsPopup };
export default tripsSlice.reducer;
